import { Component, OnInit, NgZone, ViewChild, Renderer2, ElementRef } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
declare var $: any;
import { FormBuilder, FormGroup, Validators, FormArray, AbstractControl } from '@angular/forms';
import { TranslateService } from '../../../_services/translate.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ApiService } from '../../../_services/api.service';
import { first } from 'rxjs/operators';
import { AnpiService } from '../../../_services/anpi-code.service';
import { NgxUiLoaderService, Loader, SPINNER, POSITION, PB_DIRECTION } from 'ngx-ui-loader';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import {} from 'googlemaps';

@Component({
  selector: 'app-link-business',
  templateUrl: './link-business.component.html',
  styleUrls: ['./link-business.component.scss']
})
export class LinkBusinessComponent implements OnInit {

  currentLang: any;
  public languageForm: FormGroup;
  public anpiAccountLinkForm: FormGroup;
  public companyDetailsForm: FormGroup
  isSubmitted = false;
  response: any
  neighborhoodlist: any;
  regionList: any;
  countryList: any;
  idproofList: any;
  cityList: any;
  anpiCode: any;
  bankdata: any;
  moneydata: any;
  companyDetails: any;
  AnpiDetails: any;
  ownerDistrictList: any;
  districtList: any;
  ownerCityList: any;
  accountDetails: any;
  companyDetailsResponse: any;
  login: any
  isAnpiSection = true;
  isBusiness: any
  minDateOfBirth: Date = new Date();
  isDisable: boolean = true;
  isIndividual: boolean = false;
  statuts_url: any;
  technical_license_url: any;
  fc_certificate_url: any;
  bank_ac_statement_url: any;
  company_stamp_url: any;
  nif_certificate_url: any;
  kbis_url: any;
  response_CompanyDetails: any;
  responseupload: any;
  fragment: any;
  imageSrc: SafeUrl;
  rejectReason: any;
  markers: any = [];
  circle: google.maps.Circle | undefined;
  @ViewChild('map', { static: true }) mapElement: any;
  map: google.maps.Map | undefined;
  geocoder: google.maps.Geocoder | undefined;
  latitude = -0.5475338280859924;
  longitude = 11.661464393713022;
  is_dts: any;

  constructor(private translate: TranslateService,
    private formBuilder: FormBuilder,
    private api: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private anpiService: AnpiService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private snackBar: MatSnackBar,
    private ngzone: NgZone,
    private datePipe: DatePipe,
    private elementRef: ElementRef,
    private location: Location,
    private renderer: Renderer2,
    private sanitizer: DomSanitizer) {
    this.minDateOfBirth.setFullYear(this.minDateOfBirth.getFullYear() - 16);
    this.route.fragment.subscribe(fragment => {
      this.fragment = fragment;
      if (this.fragment == "cnssresubmit" || this.fragment == "cnamgsresubmit" || this.fragment == "managecompany") {
        console.log("8888888888888888888")
        setTimeout(() => {
          this.isAnpiSection = false
        }, 100);
        this.getCompanyDetails();

      }
    });

  }
  ngOnInit() {
    const data = localStorage.getItem('currentUserDetails');
    if (data) {
      this.accountDetails = JSON.parse(data);
      this.login = this.accountDetails.current_user;
      console.log("36 login value:", this.login)
      if (this.accountDetails.GNI == "1") {
        this.isBusiness = true;
      }
    }
    this.languageForm = this.formBuilder.group({
      lang: ['', []],
    });
    this.anpiAccountLinkForm = this.formBuilder.group({
      // anpi_code: ['', [Validators.required, Validators.pattern(/^\S*$/)]],
      anpi_code: ['', [Validators.required]],
      is_cnamgs: [true], // Default value is true (checked)
      is_cnss: [true], // Default value is true (checked)
    });
    this.companyDetailsForm = this.formBuilder.group({

      anpi_no: [''],
      nif: ['', [Validators.required]],
      rccm: ['' , [Validators.required]],
      vol: [''],
      folio: [''],
      cnss: [''],
      cnamgs: ['', [ Validators.pattern(/^\d{3}-\d{3}-\d{3}-\d{3}$/)]],
      legal_status: ['', [ Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      // company_type: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9 ]+$")]],
      name: ['', [ Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      mobile: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
      trade_name: ['', [Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      acrononym: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      business_city_name: ['', [Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      business_district_name: ['', [Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      business_neighborhood_name: ['', [Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      // street: ['', [Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      street: [''],
      place: ['', [Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      business_post_box: ['', [Validators.required, Validators.pattern("^(?! *$)[a-zA-Z0-9 -]+$")]],
      business_region_name: ['', [Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      // locality: ['', [Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      locality: [''],
      telephone: ['', [ Validators.pattern("^[0-9]*$")]],
      email: ['', [ Validators.email, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$")]],
      website: ['', [Validators.pattern("^www\\.[a-zA-Z0-9-]+\\.[a-zA-Z]{2,}$")]],
      fax: ['', [Validators.pattern("^(?! *$)[a-zA-Z0-9 -]+$")]],
      last_name: ['', [Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ,'` -]+$")]],
      first_name: ['', [Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ,'` -]+$")]],
      birth_date: ['', [Validators.required]],
      birth_place: ['', [ Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      owner_country_id: [''],
      owner_nationality_id: ['', [Validators.required]],
      owner_region_name: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      owner_city_name: ['', [ Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      owner_neighbourhood_name: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      owner_district_name: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      owner_street_name: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      owner_door_no: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9 ]+$")]],
      owner_place: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      owner_locality: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      id_proof: ['',[Validators.required]],
      id_number: ['',[Validators.required]],
      phone_no: ['', [ Validators.pattern("^[0-9]*$")]],
      owner_post_box: ['', [Validators.required, Validators.pattern("^(?! *$)[a-zA-Z0-9 -]+$")]],
      // cnss_id: ['', [Validators.pattern("^\\d{3}-\\d{3,10}-[A-Z]$")]],
      owner_email: ['', [Validators.email, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$")]],
      confirm_account: ['', [Validators.requiredTrue]],
      //new fields
      administration_name: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      local_community: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      // door_no: [''],
      department: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      municipality: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      township: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      takeover_date: [''],
      business_manager: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      employer_plan: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ ]+(?:\s[a-zA-ZÀ-ÖØ-öø-ÿ ]+)*$")]],
      tax: ['', [Validators.pattern("^(?! )[a-zA-Z0-9][a-zA-Z0-9 -]*$")]],
      seeg_subscription_no: [''],
      guardianship: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ,'` -]+$")]],
      branch_of_activity: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ,'` -]+$")]],
      worker_men: ['', [Validators.pattern("^[0-9]*$"), Validators.maxLength(6)]],
      worker_women: ['', [Validators.pattern("^[0-9]*$"), Validators.maxLength(6)]],
      interns_men_no: ['', [Validators.pattern("^[0-9]*$"), Validators.maxLength(6)]],
      interns_women_no: ['', [Validators.pattern("^[0-9]*$"), Validators.maxLength(6)]],
      activity: ['', [Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      // no_of_interns: [''],
      maiden_name: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ,'` -]+$")]],
      position: ['', [Validators.pattern("^(?=.*[a-zA-ZÀ-ÖØ-öø-ÿ])[a-zA-ZÀ-ÖØ-öø-ÿ0-9 ]+$")]],
      manager: [1],
      // date_of_creation: [''],
      employer_fund: ['', [Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ ]+(?:\s[a-zA-ZÀ-ÖØ-öø-ÿ ]+)*$")]],
      employer_code: ['', [Validators.pattern("^(?! )[a-zA-Z0-9-]+(?: [a-zA-Z0-9-]+)*$")]],
      address: ['', [ Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ0-9., ()&+'`-]+$")]],
      insurrance_no: ['', [Validators.pattern(/^\d{3}-\d{3}-\d{3}-\d{3}$/)]],
      signature: [''],
      // statuts: [''],
      // technical_license: [''],
      // business_fc_certificate: [''],
      bank_slip: [''], //need to be inside the  selected_bank_id array - malin
      latitude: [],
      longitude: [],
      company_stamp: [''],
      nif_certificate: [''],
      map_address: ['', [ Validators.pattern(/^[^\s][\s\S]*$/)]],
      //new fields ends
      selected_bank_id: this.formBuilder.array([])
    });

    console.log(":11111111111", this.companyDetailsForm.controls['banks'])

    if (!this.api.getValidationStatus()) {
      this.api.getFormValidation(this.companyDetailsForm);
    }
    this.getCountryData();
    this.getRegionData();
    console.log("116")
    // this.getNeighbourhoodList();
    this.getIdProofList()
    this.currentLang = localStorage.getItem('language') || "fr";
    this.languageForm.get('lang').setValue(this.currentLang);
    if (this.currentLang == 'fr') {
      $('.checkbox').prop('checked', false);
    } else {
      $('.checkbox').prop('checked', true);
    }
    // this.getBanks();
    console.log(this.languageForm.get('lang').value);
  }

  get selectedBanks(): FormArray {
    return this.companyDetailsForm.get('selected_bank_id') as FormArray;
  }


  refetchAnpiCode() {
    this.companyDetailsForm.reset();
    console.log("refetchAnpiCode");

    this.ngxUiLoaderService.start();
    var data = {};
    this.api.relinkBusiness(data).pipe(first())
      .subscribe(res => {
          this.ngxUiLoaderService.stop();
          this.response = res.result;
          console.log("148 companyDetails:", res.result)
          if (res.status == 200) {
            // Store is_dts value first
            if (this.response.is_dts ) {
              console.log('fsfbsyhfguasydfahkajdf');
              this.is_dts = this.response.is_dts;
            }
            this.AnpiDetails = this.response.anpi_details;
            this.companyDetails = this.AnpiDetails;
            console.log(this.companyDetails)
            this.bankdata = this.response.bank;
            console.log(this.bankdata)
            this.selectedBanks.clear();
            if (this.bankdata) {
              this.bankdata.forEach(item => {
                this.selectedBanks.push(
                  this.formBuilder.group({
                    bank_id: item.bank_id,
                    bank_receipt: item.bank_receipt
                  }));
              });
            } else {
              this.selectedBanks.clearValidators();
              this.selectedBanks.updateValueAndValidity();
            }
            this.setCompanyDetailsValues();
            // Update validators AFTER setCompanyDetailsValues to prevent overwriting
            if (this.is_dts) {
              this.updateDtsValidators();
            }
            this.makeInputReadOnly();
            console.log("CompanyDetails:", this.companyDetails)
            // $('#bank-Section').css('display', 'none');
            window.scrollTo({ top: 0, behavior: 'smooth' });
            // $('#anpi-section').css('display', 'none');
            // $('#company-details-section').css('display', 'block');
            this.isAnpiSection = false;
            console.log("263 latitude" + this.latitude, this.longitude);
            this.generateMap(this.latitude, this.longitude);
            console.log("254" + this.latitude, this.longitude);
          } else {
            this.snackBar.open(res.message, "OK", {
              duration: 5000,
            });
          }

        },
        error => {
          this.ngxUiLoaderService.stop();
          this.isSubmitted = false;
        });

  }
  onSubmitAnpiCode() {

    this.isSubmitted = true;
    console.log(this.isSubmitted)
    if (this.anpiAccountLinkForm.invalid) {
      console.log("196", this.anpiAccountLinkForm)
      return;
    }
    var data = this.anpiAccountLinkForm.value;
    // Convert boolean values to 1/0 for API compatibility
    data.is_cnamgs = data.is_cnamgs ;
    data.is_cnss = data.is_cnss ;

    console.log(data, "dataaaaaa");
    
    
    this.ngxUiLoaderService.start();
    //firstcall suby
   
    this.api.linkBusiness(data).pipe(first())
      .subscribe(res => {
          this.isSubmitted = false;
          this.ngxUiLoaderService.stop();
          this.response = res.result;
          console.log("148 companyDetails:", res.result)
          if (res.status == 200) {
            this.is_dts = this.response.is_dts;
            console.log(this.is_dts, "this.is_dts");
            
            this.AnpiDetails = this.response.business;
            this.companyDetails = this.response.business;
            console.log(this.companyDetails)
            this.bankdata = this.response.bank;
            console.log(this.bankdata)
            this.selectedBanks.clear();
            if (this.bankdata) {
              this.bankdata.forEach(item => {
                this.selectedBanks.push(
                  this.formBuilder.group({
                    bank_id: item.bank_id,
                    bank_receipt: item.bank_receipt
                  }));
              });
            } else {
              this.selectedBanks.clearValidators();
              this.selectedBanks.updateValueAndValidity();
            }
            this.setCompanyDetailsValues();
            // Update CNSS and CNAMGS validators based on is_dts value AFTER setCompanyDetailsValues
            this.updateDtsValidators();
            this.makeInputReadOnly();
            console.log("CompanyDetails:", this.companyDetails)
            // $('#bank-Section').css('display', 'none');
            window.scrollTo({ top: 0, behavior: 'smooth' });
            // $('#anpi-section').css('display', 'none');
            // $('#company-details-section').css('display', 'block');
            this.isAnpiSection = false
            console.log("323 latitude")
            this.generateMap(this.latitude, this.longitude);
          } else {
            this.snackBar.open(res.message, "OK", {
              duration: 5000,
            });
          }

        },
        error => {
          this.ngxUiLoaderService.stop();
          this.isSubmitted = false;
        });

  }

  getCompanyDetails() {

    console.log("getccpsCompanyDetails")
    this.ngxUiLoaderService.start();
    this.api.getccpsCompanyDetails().pipe(first())
      .subscribe(data => {
          this.ngxUiLoaderService.stop();
          this.companyDetailsResponse = data;
          console.log("companyDetailsResponse");
          console.log(this.companyDetailsResponse);

          if (this.companyDetailsResponse.status == 200) {
            console.log("inside 2000");
            this.AnpiDetails = this.companyDetailsResponse.result.anpi_details;
            this.companyDetails = this.companyDetailsResponse.result.company_details;
            this.bankdata = this.companyDetailsResponse.result.bank_details;

            this.rejectReason = this.companyDetailsResponse.result.verification;
            this.setCompanyDetailsValues();
            this.makeInputReadOnly();
          } else {
            this.snackBar.open(data.message, "OK", {
              duration: 5000,
            });
          }
        },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }

  // handleChange(evt) {
  //   console.log("dsfsdfsdfsdfsdfsdfsdfdfdf")
  //   window.scrollTo({ top: 0, behavior: 'smooth' });
  //   var target = evt.target.value;
  //   setTimeout(function() {
  //     if (target == "anpi") {
  //       $('#create-account-section').css('display', 'none');
  //       $('#anpi-section').css('display', 'block');

  //     } else if (target == "noanpi") {
  //       $('#create-account-section').css('display', 'none');
  //       $('#noanpi-section').css('display', 'block');
  //     }
  //   }, 400);
  // }
  makeInputReadOnly_malin() {
    Object.keys(this.companyDetailsForm.controls).forEach(controlName => {
      const control = this.companyDetailsForm.get(controlName);
      if (control && control.value !== null && control.value !== undefined && control.value !== '') {
        if (controlName != 'selected_bank_id' && controlName != 'manager') {
          control.disable();
          const inputElements = document.querySelectorAll(`[formcontrolname="${controlName}"]`);
          inputElements.forEach(inputElement => {
            inputElement.classList.add('disabled-input');
          });


        }
      }
    });
  }
  makeInputReadOnly() {
    console.log("2222222222222222222222222222222222222222222222222222222");
    console.log("2222222222222222222222222222222222222222222222222222222");
    console.log("2222222222222222222222222222222222222222222222222222222");
    console.log(this.AnpiDetails);
    console.log("2222222222222222222222222222222222222222222222222222222");
    console.log("2222222222222222222222222222222222222222222222222222222");


    Object.keys(this.companyDetailsForm.controls).forEach(controlName => {
      console.log(controlName + "-------" + this.AnpiDetails[controlName]);
      const control = this.companyDetailsForm.get(controlName);
      if (control && this.AnpiDetails[controlName] !== null && this.AnpiDetails[controlName] !== undefined && this.AnpiDetails[controlName] !== '') {
        if (controlName != 'selected_bank_id' && controlName != 'manager') {

          console.log("11111111-" + controlName);
          control.disable();
          const inputElements = document.querySelectorAll(`[formcontrolname="${controlName}"]`);
          inputElements.forEach(inputElement => {
            inputElement.classList.add('disabled-input');
          });


        }
      }
    });
  }
  openNav() {
    document.getElementById("mySidenav").style.width = "305px";
    document.getElementById("main").style.marginRight = "0px";
    document.getElementById("menuOverlay").style.display = "block";

  }

  closeNav() {
    document.getElementById("mySidenav").style.width = "0";
    document.getElementById("main").style.marginRight = "0";
    document.getElementById("menuOverlay").style.display = "none";
  }

  setLang(lang) {
    console.log('aaa')
    this.currentLang = lang;
    var useLang = { language: this.currentLang };
    this.translate.setCurrentLangage(useLang);
    localStorage.setItem('language', lang);
    this.changeLang();
  }

  changeLang() {
    this.translate.use(this.currentLang);
  }

  checkValue(e) {
    console.log(e)
    if (e == true) {
      this.setLang('fr');
      $("#lang").text("FR");
    } else {
      this.setLang('en');
      $("#lang").text("EN");
    }
  }
  findInvalidControls() {
    const invalid = [];
    const controls = this.companyDetailsForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    console.log("888888888 888888 8invalid");
    console.log(invalid);
    return invalid;
  }
  onSubmitCompanyDetails() {
    this.isSubmitted = true;
    this.findInvalidControls()
    console.log("280", this.companyDetailsForm)

    if (this.companyDetailsForm.invalid) {
      console.log("282", this.companyDetailsForm)
      this.scrollToFirstInvalidControl()
      return;
    }

    var data = {} as {
      takeover_date: any;
      birth_date: any;type: string,
      confirm_account ? : any
    };

    for (const controlName in this.companyDetailsForm.controls) {
      const formControl = this.companyDetailsForm.get(controlName);
      if (formControl) {
        data[controlName] = formControl.value;
      }
    }
    if (data) {
      delete data.confirm_account;
      console.log(this.datePipe.transform(data.birth_date, 'dd-MM-yyyy'))
      data['birth_date'] = this.datePipe.transform(data.birth_date, 'dd-MM-yyyy');

      data['takeover_date'] = this.datePipe.transform(data.takeover_date, 'dd-MM-yyyy');

    }
    // data['business_technical_license'] = this.companyDetails
    console.log(data);
    console.log("283", data)
    this.ngxUiLoaderService.start();
    this.api.companyDetails(data).pipe(first())
      .subscribe(res => {
          this.response_CompanyDetails = res;
          // console.log(this.response , "Entha varthanammmm");
          if (this.response_CompanyDetails.status == 200) {
            this.isSubmitted = false;
            this.companyDetails = this.response_CompanyDetails.business;
            console.log(this.companyDetails)
            this.anpiService.emitEvent();
            this.getAccountData();

          } else {
            this.ngxUiLoaderService.stop();
            this.snackBar.open(this.response_CompanyDetails.message, "OK", {
              duration: 5000,
            });
          }
        },
        error => {
          this.ngxUiLoaderService.stop();
        });

  }
  scrollToFirstInvalidControl() {
    for (const controlName in this.companyDetailsForm.controls) {
      const control = this.companyDetailsForm.get(controlName);
      if (control.invalid) {
        const firstInvalidControl = this.elementRef.nativeElement.querySelector(`[formcontrolname="${controlName}"]`);
        if (firstInvalidControl) {
          firstInvalidControl.scrollIntoView({ behavior: 'smooth', block: 'start' });
          break; // Stop after scrolling to the first invalid control
        }
      }
    }
  }
  getAccountData() {
    console.log("442 get employer details")
    this.api.getAccountDetails().pipe(first())
      .subscribe(res => {
          this.ngxUiLoaderService.stop();
          this.response = res.results;
          if (res.status == 200) {
            console.log("88", res)
            this.accountDetails = this.response;
            const data = JSON.stringify(this.accountDetails);
            localStorage.setItem('currentUserDetails', data);
            if (this.fragment == "cnssresubmit") {
              this.router.navigate(['/cnss-approval-form'], { state: { show_modal: '1' } });
            } else if (this.fragment == "cnamgsresubmit") {
              this.router.navigate(['/cnamgs-form'], { state: { show_modal: '1' } });
            } else {
              this.router.navigate(['/dashboard'], { state: { show_modal: '1' } });
            }
          }
        },
        error => {
          console.log("errorrrrrrrrr")
          this.ngxUiLoaderService.stop();
        });
    console.log("no result")
  }
  getChangelang(e) {
    if (e.target.checked == true) {
      var lang = 'en';
    } else {
      lang = 'fr';
    }
    this.setLang(lang);
  }

  getBanks() {
    this.api.getBanks().pipe(first())
      .subscribe(data => {
        setTimeout(() => {
          this.ngzone.run(() => {
            console.log("fdsfdsfsdfd")
            $('#bank1').prop('checked', true);
            console.log($('#bank1'))
            console.log($('#money1'))
            $('#money1').prop('checked', true);
          });
        }, 2000)
      })
  }

  setCompanyDetailsValues() {
    if (this.companyDetails) {
      console.log('anpi random')
      this.companyDetailsForm.controls['business_region_name'].setValue(this.companyDetails.business_region_name);
      // if (this.g.region.value) {
      //   const region = this.g.region.value;
      //   console.log("370", region)
      //   this.changeRegion(region, 1);
      // }
      this.companyDetailsForm.controls['business_city_name'].setValue(this.companyDetails.business_city_name);
      // if (this.g.city.value) {
      //   const city = this.g.city.value;
      //   console.log("370", city)
      //   this.changeCity(city);
      // }
      this.companyDetailsForm.controls['business_district_name'].setValue(this.companyDetails.business_district_name);
      this.companyDetailsForm.controls['business_neighborhood_name'].setValue(this.companyDetails.business_neighborhood_name);
      this.companyDetailsForm.controls['anpi_no'].setValue(this.companyDetails.anpi_no);
      this.companyDetailsForm.controls['nif'].setValue(this.companyDetails.nif);
      this.companyDetailsForm.controls['rccm'].setValue(this.companyDetails.rccm);
      if (this.companyDetails.business_type == '0') {
        // this.isIndividual = true

        const emptyList = this.checkEmptyKeys(this.companyDetails);
        console.log(emptyList)
        if (emptyList.length > 0) {
          emptyList.forEach(key => {
            switch (key) {
              case 'vol':
                {
                  this.companyDetailsForm.controls['vol'].setValidators([Validators.pattern("^(?! )[-a-zA-ZÀ-ÖØ-öø-ÿ0-9, ]+$")]);
                  this.companyDetailsForm.controls['vol'].updateValueAndValidity();
                  break;
                }
              case 'folio':
                {
                  this.companyDetailsForm.controls['folio'].setValidators([Validators.pattern("^(?! )[-a-zA-ZÀ-ÖØ-öø-ÿ0-9, ]+$")]);
                  this.companyDetailsForm.controls['folio'].updateValueAndValidity();
                }
              case 'cnss':
                {
                  this.companyDetailsForm.controls['cnss'].setValidators([Validators.pattern("^\\d{3}-\\d{3,10}-[A-Z]$")]);
                  this.companyDetailsForm.controls['cnss'].updateValueAndValidity();
                }
              case 'cnamgs':
                {
                  this.companyDetailsForm.controls['cnamgs'].setValidators([Validators.pattern(/^\d{3}-\d{3}-\d{3}-\d{3}$/)]);
                  this.companyDetailsForm.controls['cnamgs'].updateValueAndValidity();
                }
              case 'id_number':
                {
                  this.companyDetailsForm.controls['id_number'].setValidators([Validators.required, Validators.pattern("^(?! )[-a-zA-ZÀ-ÖØ-öø-ÿ0-9, ]+$")]);
                  this.companyDetailsForm.controls['id_number'].updateValueAndValidity();
                }
              case ' seeg_subscription_no':
                {
                  this.companyDetailsForm.controls['seeg_subscription_no'].setValidators([Validators.pattern("^(?! )[0-9]+(/?[0-9 ]+)?$")]);
                  this.companyDetailsForm.controls['seeg_subscription_no'].updateValueAndValidity();
                }

            }
          });
        } else {
          console.log("656")
        }

      } else {
        console.log("655")
        const emptyList = this.checkEmptyKeys(this.companyDetails);
        if (emptyList.length > 0) {
          this.companyDetailsForm.controls['vol'].setValidators([Validators.required, Validators.pattern("^(?! )[-a-zA-ZÀ-ÖØ-öø-ÿ0-9, ]+$")]);
          this.companyDetailsForm.controls['vol'].updateValueAndValidity();

          this.companyDetailsForm.controls['folio'].setValidators([Validators.required, Validators.pattern("^(?! )[-a-zA-ZÀ-ÖØ-öø-ÿ0-9, ]+$")]);
          this.companyDetailsForm.controls['folio'].updateValueAndValidity();

          this.companyDetailsForm.controls['cnss'].setValidators([Validators.required, Validators.pattern("^\\d{3}-\\d{3,10}-[A-Z]$")]);
          this.companyDetailsForm.controls['cnss'].updateValueAndValidity();
          this.companyDetailsForm.controls['cnamgs'].setValidators([Validators.required, Validators.pattern(/^\d{3}-\d{3}-\d{3}-\d{3}$/)]);
          this.companyDetailsForm.controls['cnamgs'].updateValueAndValidity();
          this.companyDetailsForm.controls['id_number'].setValidators([Validators.required, Validators.pattern("^(?! )[-a-zA-ZÀ-ÖØ-öø-ÿ0-9, ]+$")]);
          this.companyDetailsForm.controls['id_number'].updateValueAndValidity();
          this.companyDetailsForm.controls['seeg_subscription_no'].setValidators([Validators.pattern("^(?! )[0-9]+(/?[0-9 ]+)?$")]);
          this.companyDetailsForm.controls['seeg_subscription_no'].updateValueAndValidity();
        } else {}
      }
      this.companyDetailsForm.controls['vol'].setValue(this.companyDetails.vol);
      this.companyDetailsForm.controls['folio'].setValue(this.companyDetails.folio);

      this.companyDetailsForm.controls['cnss'].setValue(this.companyDetails.cnss);
      this.companyDetailsForm.controls['cnamgs'].setValue(this.companyDetails.cnamgs);
      this.companyDetailsForm.controls['legal_status'].setValue(this.companyDetails.legal_status);
      // this.companyDetailsForm.controls['company_type'].setValue(this.companyDetails.company_type);
      this.companyDetailsForm.controls['name'].setValue(this.companyDetails.name);
      this.companyDetailsForm.controls['mobile'].setValue(this.companyDetails.mobile);
      this.companyDetailsForm.controls['trade_name'].setValue(this.companyDetails.trade_name);
      this.companyDetailsForm.controls['acrononym'].setValue(this.companyDetails.acrononym);
      this.companyDetailsForm.controls['owner_post_box'].setValue(this.companyDetails.owner_post_box);

      this.companyDetailsForm.controls['street'].setValue(this.companyDetails.street);
      this.companyDetailsForm.controls['place'].setValue(this.companyDetails.place);
      this.companyDetailsForm.controls['business_post_box'].setValue(this.companyDetails.business_post_box);
      this.companyDetailsForm.controls['locality'].setValue(this.companyDetails.locality);
      //malin send neighborhood id  business_address_info_neighborhood_name
      this.companyDetailsForm.controls['owner_neighbourhood_name'].setValue(this.companyDetails.owner_neighbourhood_name);
      this.companyDetailsForm.controls['owner_district_name'].setValue(this.companyDetails.owner_district_name);
      this.companyDetailsForm.controls['owner_street_name'].setValue(this.companyDetails.owner_street_name);
      this.companyDetailsForm.controls['owner_door_no'].setValue(this.companyDetails.owner_door_no);
      this.companyDetailsForm.controls['owner_place'].setValue(this.companyDetails.owner_place);
      this.companyDetailsForm.controls['owner_locality'].setValue(this.companyDetails.owner_locality);
      this.companyDetailsForm.controls['telephone'].setValue(this.companyDetails.telephone);
      this.companyDetailsForm.controls['email'].setValue(this.companyDetails.email);

      this.companyDetailsForm.controls['website'].setValue(this.companyDetails.website);

      this.companyDetailsForm.controls['fax'].setValue(this.companyDetails.fax);
      this.companyDetailsForm.controls['last_name'].setValue(this.companyDetails.last_name);
      this.companyDetailsForm.controls['first_name'].setValue(this.companyDetails.first_name);
      if (this.companyDetails.birth_date)
        this.companyDetailsForm.controls['birth_date'].setValue(this.companyDetails.birth_date);
      console.log(this.companyDetails.birth_date)
      this.companyDetailsForm.controls['birth_place'].setValue(this.companyDetails.birth_place);
      this.companyDetailsForm.controls['owner_country_id'].setValue(this.companyDetails.owner_country_id);
      this.companyDetailsForm.controls['owner_nationality_id'].setValue(this.companyDetails.owner_nationality_id);
      this.companyDetailsForm.controls['owner_region_name'].setValue(this.companyDetails.owner_region_name);
      this.companyDetailsForm.controls['owner_city_name'].setValue(this.companyDetails.owner_city_name);
      // if (this.g.owner_region.value) {
      //   const region = this.g.owner_region.value;
      //   console.log("370", region)
      //   this.changeRegion(region, 2);
      // }
      this.companyDetailsForm.controls['id_proof'].setValue(this.companyDetails.id_proof);
      this.companyDetailsForm.controls['id_number'].setValue(this.companyDetails.id_number);
      this.companyDetailsForm.controls['phone_no'].setValue(this.companyDetails.phone_no);
      // this.companyDetailsForm.controls['cnss_id'].setValue(this.companyDetails.cnss_id);
      this.companyDetailsForm.controls['owner_email'].setValue(this.companyDetails.owner_email);
      //new fields added
      this.bank_ac_statement_url = this.companyDetails.bank_slip;
      this.statuts_url = this.companyDetails.statuts;
      this.technical_license_url = this.companyDetails.technical_license;
      this.fc_certificate_url = this.companyDetails.fc;
      this.company_stamp_url = this.companyDetails.company_stamp;
      this.nif_certificate_url = this.companyDetails.nif_certificate_url;
      this.kbis_url = this.companyDetails.kbis_certificate;
      this.companyDetailsForm.controls['nif_certificate'].setValue(this.companyDetails.nif_certificate);
      this.companyDetailsForm.controls['company_stamp'].setValue(this.companyDetails.company_stamp_name);
      this.companyDetailsForm.controls['administration_name'].setValue(this.companyDetails.administration_name);
      this.companyDetailsForm.controls['local_community'].setValue(this.companyDetails.local_community);
      // this.companyDetailsForm.controls['door_no'].setValue(this.companyDetails.door_no);
      this.companyDetailsForm.controls['department'].setValue(this.companyDetails.department);
      this.companyDetailsForm.controls['municipality'].setValue(this.companyDetails.municipality);
      this.companyDetailsForm.controls['township'].setValue(this.companyDetails.township);
      this.companyDetailsForm.controls['takeover_date'].setValue(this.companyDetails.takeover_date);
      this.companyDetailsForm.controls['business_manager'].setValue(this.companyDetails.business_manager);
      this.companyDetailsForm.controls['employer_plan'].setValue(this.companyDetails.employer_plan);
      this.companyDetailsForm.controls['tax'].setValue(this.companyDetails.tax);
      this.companyDetailsForm.controls['seeg_subscription_no'].setValue(this.companyDetails.seeg_subscription_no);
      this.companyDetailsForm.controls['guardianship'].setValue(this.companyDetails.guardianship);
      this.companyDetailsForm.controls['branch_of_activity'].setValue(this.companyDetails.branch_of_activity);
      this.companyDetailsForm.controls['worker_men'].setValue(this.companyDetails.worker_men);
      this.companyDetailsForm.controls['worker_women'].setValue(this.companyDetails.worker_women);
      this.companyDetailsForm.controls['activity'].setValue(this.companyDetails.activity);
      this.companyDetailsForm.controls['interns_women_no'].setValue(this.companyDetails.interns_women_no);
      this.companyDetailsForm.controls['interns_men_no'].setValue(this.companyDetails.interns_men_no);
      this.companyDetailsForm.controls['maiden_name'].setValue(this.companyDetails.maiden_name);
      this.companyDetailsForm.controls['position'].setValue(this.companyDetails.position);
      if (this.companyDetails.manager != null ) {
        console.log("604")
        this.companyDetailsForm.controls['manager'].setValue(this.companyDetails.manager);
        const inputElements = document.querySelectorAll(`[formcontrolname="manager"]`);
        inputElements.forEach(inputElement => {
          inputElement.classList.add('disabled-input');
        });
      }
      // this.companyDetailsForm.controls['date_of_creation'].setValue(this.companyDetails.date_of_creation);
      this.companyDetailsForm.controls['employer_fund'].setValue(this.companyDetails.employer_fund);
      this.companyDetailsForm.controls['employer_code'].setValue(this.companyDetails.employer_code);
      this.companyDetailsForm.controls['address'].setValue(this.companyDetails.address);
      this.companyDetailsForm.controls['insurrance_no'].setValue(this.companyDetails.insurrance_no);
      this.companyDetailsForm.controls['latitude'].setValue(this.latitude);
      this.companyDetailsForm.controls['longitude'].setValue(this.longitude);
      if (this.companyDetails.latitude && this.companyDetails.longitude) {
        console.log(this.companyDetails.latitude, this.companyDetails.longitude)
        this.generateMap(this.companyDetails.latitude, this.companyDetails.longitude);
        this.companyDetailsForm.get('map_address').clearValidators();
        this.companyDetailsForm.get('map_address').updateValueAndValidity();
      } else {
        const latitude = -0.5475338280859924;
        const longitude = 11.661464393713022;
        this.generateMap(latitude, longitude);
        this.companyDetailsForm.controls['map_address'].setValidators([ Validators.pattern(/^[^\s][\s\S]*$/)]);
        this.companyDetailsForm.controls['map_address'].updateValueAndValidity();
      }

    }
    // end of new fields

  }

  checkEmptyKeys(data) {
    const emptyKeys = [];
    for (const key in data) {
      if (data[key] === undefined || data[key] === null || data[key] === "") {
        emptyKeys.push(key);
      }
    }
    return emptyKeys;
  }

  updateDtsValidators() {
    console.log('Updating DTS validators, is_dts:', this.is_dts);
    
    if (this.is_dts == 1) {
      // If is_dts is 1, make CNSS and CNAMGS required
      this.companyDetailsForm.controls['cnss'].setValidators([
        Validators.required,
        Validators.pattern("^\\d{3}-\\d{3,10}-[A-Z]$")
      ]);
      this.companyDetailsForm.controls['cnss'].updateValueAndValidity();
      this.companyDetailsForm.controls['cnss'].markAsTouched();
      
      this.companyDetailsForm.controls['cnamgs'].setValidators([
        Validators.required,
        Validators.pattern(/^\d{3}-\d{3}-\d{3}-\d{3}$/)
      ]);
      this.companyDetailsForm.controls['cnamgs'].updateValueAndValidity();
      this.companyDetailsForm.controls['cnamgs'].markAsTouched();
      
      console.log('CNSS and CNAMGS are now required');
      console.log('CNSS errors:', this.companyDetailsForm.controls['cnss'].errors);
      console.log('CNAMGS errors:', this.companyDetailsForm.controls['cnamgs'].errors);
    } else {
      // If is_dts is not 1, keep them optional (only pattern validation)
      this.companyDetailsForm.controls['cnss'].setValidators([
        Validators.pattern("^\\d{3}-\\d{3,10}-[A-Z]$")
      ]);
      this.companyDetailsForm.controls['cnss'].updateValueAndValidity();
      
      this.companyDetailsForm.controls['cnamgs'].setValidators([
        Validators.pattern(/^\d{3}-\d{3}-\d{3}-\d{3}$/)
      ]);
      this.companyDetailsForm.controls['cnamgs'].updateValueAndValidity();
      
      console.log('CNSS and CNAMGS are optional');
    }
  }

  get f() {
    return this.anpiAccountLinkForm.controls;
  }
  get g() {
    return this.companyDetailsForm.controls;
  }
  goBack() {
    this.location.back();
    // $('#company-details-section').css('display', 'none');
    // $('#anpi-section').css('display', 'block');
    this.isAnpiSection = true
  }
  onChange(id, isChecked: boolean) {
    console.log(id)
    if (isChecked) {
      // this.formBuilder.control(id)
      this.selectedBanks.push(
        this.formBuilder.group({
          bank_id: id.bank_id,
          bank_receipt: id.bank_receipt
        }));
      console.log(this.selectedBanks)
    } else {
      console.log("469")
      for (let i = this.selectedBanks.length - 1; i >= 0; i--) {
        if (this.selectedBanks.at(i).get('bank_id').value === id.bank_id) {
          this.selectedBanks.removeAt(i);
          break; // Stop iterating after removing the first match
        }
      }
      console.log(this.selectedBanks)
      // const index = this.selectedBanks.controls.findIndex(x => x.value === id);
      // this.selectedBanks.removeAt(index);
    }
  }
  // changeRegion(region, val) {
  //   if (val == 1) {
  //     console.log("475")
  //     this.cityList = null;
  //     this.districtList = null;
  //     // this.g.business_city_name.setValue(null);
  //     // this.g.business_city_name.updateValueAndValidity();
  //     // this.g.business_district_name.setValue(null);
  //     // this.g.business_district_name.clearValidators();
  //     // this.g.business_district_name.updateValueAndValidity();
  //   } else {
  //     console.log("483")
  //     this.ownerCityList = null;
  //     this.ownerDistrictList = null;
  //     // this.g.owner_city_name.setValue(null);
  //     // this.g.owner_city_name.updateValueAndValidity();
  //   }
  //   console.log("486", region)
  //   this.ngxUiLoaderService.start();
  //   this.api.getCityList(region).pipe(first())
  //     .subscribe(res => {
  //         this.ngxUiLoaderService.stop();
  //         this.response = res;
  //         if (this.response.status == 200) {
  //           if (val == 1) {
  //             this.cityList = this.response.results;
  //           } else {
  //             this.ownerCityList = this.response.results;
  //           }
  //           console.log("501", this.cityList)
  //           console.log("502", this.ownerCityList)
  //         } else {
  //           this.snackBar.open(res.message, "OK", {
  //             duration: 5000,
  //           });
  //         }
  //       },
  //       error => {
  //         this.ngxUiLoaderService.stop();
  //       });
  // }

  // changeCity(city) {

  //   console.log("518")
  //   this.districtList = null;
  //   this.g.district.setValue(null);
  //   this.g.district.updateValueAndValidity();
  //   console.log("492", city)
  //   this.ngxUiLoaderService.start();
  //   this.api.getDistrictList(city).pipe(first())
  //     .subscribe(res => {
  //         this.ngxUiLoaderService.stop();
  //         this.response = res;
  //         if (this.response.status == 200) {
  //           if (this.response.results.length === 0) {
  //             this.g.district.clearValidators();
  //             this.g.district.updateValueAndValidity();
  //           } else {
  //             this.g.district.setValidators([Validators.required]);
  //             this.g.district.updateValueAndValidity();
  //             this.districtList = this.response.results;
  //             console.log("544", this.districtList)
  //           }
  //         } else {
  //           this.snackBar.open(res.message, "OK", {
  //             duration: 5000,
  //           });
  //         }
  //       },
  //       error => {
  //         this.ngxUiLoaderService.stop();
  //       });
  // }
  // changeDistrict(district) {
  //   this.g.neighborhood.setValue(null);
  //   this.g.neighborhood.updateValueAndValidity();
  //   if (this.g.city.value) {
  //     var data = {
  //       city_id: this.g.city.value,
  //       district_id: district
  //     };
  //   } else {
  //     return
  //   }
  //   console.log("521", data)
  //   this.ngxUiLoaderService.start();
  //   this.api.getNeighbourhoodList(data).pipe(first())
  //     .subscribe(res => {
  //         this.ngxUiLoaderService.stop();
  //         this.response = res;
  //         console.log("527", this.response)
  //         if (this.response.status == 200) {
  //           if (this.response.results.length === 0) {
  //             this.g.neighborhood.clearValidators();
  //             this.g.neighborhood.updateValueAndValidity();
  //           } else {
  //             this.neighborhoodlist = this.response.results;
  //           }

  //         } else {
  //           this.snackBar.open(res.message, "OK", {
  //             duration: 5000,
  //           });
  //         }
  //       },
  //       error => {
  //         this.ngxUiLoaderService.stop();
  //       });
  // }

  getCountryData() {

    this.api.getCountryList().pipe(first())
      .subscribe(res => {
          this.response = res;
          if (this.response.status == 200) {
            this.countryList = this.response.results;
            console.log("503", this.countryList)
          } else {
            this.snackBar.open(res.message, "OK", {
              duration: 5000,
            });
          }
        },
        error => {

        });
  }
  getRegionData() {
    this.api.getRegionList().pipe(first())
      .subscribe(res => {
          this.response = res;
          http: //localhost:4200/employees
            console.log("541", this.response)
          if (this.response.status == 200) {
            this.regionList = this.response.results;
            console.log("522", this.regionList)
          } else {
            this.snackBar.open(res.message, "OK", {
              duration: 5000,
            });
          }
        },
        error => {});
  }
  // getNeighbourhoodList() {
  //   console.log("612")
  //   this.api.getNeighbourhoodList().pipe(first())
  //     .subscribe(res => {
  //         this.response = res;
  //         console.log("617", this.response)
  //         if (this.response.status == 200) {
  //           if (this.response.results.length === 0) {
  //             // this.g.neighborhood.clearValidators();
  //             // this.g.neighborhood.updateValueAndValidity();

  //           } else {
  //             this.neighborhoodlist = this.response.results;
  //             console.log("626", this.neighborhoodlist)
  //           }

  //         } else {
  //           this.snackBar.open(res.message, "OK", {
  //             duration: 5000,
  //           });
  //         }
  //       },
  //       error => {});
  // }
  getIdProofList() {
    let data = {
      identityType: '2'
    }
    this.api.getidTypeList(data).pipe(first())
      .subscribe(res => {
          this.response = res;
          console.log("682", this.response)
          if (this.response.status == 200) {
            this.idproofList = this.response.results;
            console.log("685", this.idproofList)
          } else {
            this.snackBar.open(res.message, "OK", {
              duration: 5000,
            });
          }
        },
        error => {});
  }

  upload(event, id) {
    console.log("sadsadsadsadsadsadsad", id)
    console.log("2250", event)
    console.log("2251", event.target.files[0])
    // const fileNameDisplay = document.getElementById(id);
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      console.log('uploaded image: ', file)
      const filename = file.name;
      var ext = filename.split('.').pop();
      if (id == 'company_stamp') {
        if (file.size > 2097152) {

          if (this.currentLang == 'fr') {
            alert('La taille du fichier doit être inférieure à 2MB')
          } else {
            alert('File Size should be less than 2MB')
          }
          return;
        }
        if (ext != 'png') {
          if (this.currentLang == 'fr') {
            alert('Type de fichier non autorisé. Les types de fichier autorisés sont . png')
          } else {
            alert('File type not allowed. Allowed file types are .png')
          }
          return;
        }
      } else {
        if (file.size > 5242880) {

          if (this.currentLang == 'fr') {
            alert('La taille du fichier doit être inférieure à 5MB')
          } else {
            alert('File Size should be less than 5MB')
          }
          return;
        }
        if (ext != 'jpg' && ext != 'JPG' && ext != 'png' && ext != 'PNG' && ext != 'JPEG' && ext != 'jpeg' && ext != 'pdf' && ext != 'PDF' && ext != 'doc' && ext != "Doc" && ext != 'docx' && ext != "DOCX" && ext != 'bmp' && ext != 'BMP' && ext != 'webp' && ext != 'heic' && ext != 'heif' && ext != 'tiff' && ext != 'TIFF') {
          if (this.currentLang == 'fr') {
            alert('Type de fichier non autorisé. Les types de fichier autorisés sont  .jpg .png .jpeg .pdf .doc .docx .bmp .webp .heic .heif .tiff')
          } else {
            alert('File type not allowed. Allowed file types are .jpg .png .jpeg .pdf .doc .docx .bmp .webp .heic .heif .tiff')
          }
          return;
        }
      }

      console.log(this.selectedBanks)
      this.ngxUiLoaderService.start();
      const target = event.target.dataset.target;
      console.log(target)
      const formData = new FormData();
      formData.append('image', file);
      formData.append('target', target);
      console.log("file is :", file)
      console.log("target is :", target)
      formData['encrypt_mode'] = false;
      // formData.append('uuid', this.businessData.business_code);
      this.api.bankSlipUpload(formData).pipe(first())
        .subscribe(data => {
            this.ngxUiLoaderService.stop();
            this.responseupload = data;
            if (this.responseupload.status == 200) {
              // if (target == 'statuts') {
              //   this.companyDetailsForm.get('statuts').setValue(this.responseupload.results.file);
              //   this.statuts_url = this.responseupload.results.imageUrl;
              // }
              //  if (target == 'technical_license') {
              //   this.companyDetailsForm.get('technical_license').setValue(this.responseupload.results.file);
              //   this.technical_license_url = this.responseupload.results.imageUrl;
              // }
              //  if (target == 'business_fc_certificate') {
              //   this.companyDetailsForm.get('business_fc_certificate').setValue(this.responseupload.results.file);
              //   this.fc_certificate_url = this.responseupload.results.imageUrl;
              // }
              if (target == 'bank_slip') {
                for (let key in this.selectedBanks.controls) {
                  console.log(this.selectedBanks.controls[key])
                  console.log(this.selectedBanks.controls[key]['controls'])
                  console.log(this.selectedBanks.controls[key]['controls'].bank_id.value)
                  console.log(this.selectedBanks.controls[key]['controls']['bank_receipt'])
                  if (this.selectedBanks.controls[key]['controls'].bank_id.value == id) {
                    this.selectedBanks.controls[key]['controls']['bank_receipt'].setValue(this.responseupload.results.file)
                    console.log(this.selectedBanks.controls[key]['controls'])
                  }
                }
              }
              this.snackBar.open(data.message, "OK", {
                duration: 5000,
              });
              // if (target == 'statuts') {
              //   this.companyDetailsForm.get('statuts').setValue(this.responseupload.results.file);
              //   this.statuts_url = this.responseupload.results.imageUrl;
              // }
              // if (target == 'technical_license') {
              //   this.companyDetailsForm.get('technical_license').setValue(this.responseupload.results.file);
              //   this.technical_license_url = this.responseupload.results.imageUrl;
              // }
              // if (target == 'business_fc_certificate') {
              //   this.companyDetailsForm.get('business_fc_certificate').setValue(this.responseupload.results.file);
              //   this.fc_certificate_url = this.responseupload.results.imageUrl;
              // }
              if (target == 'bank_slip') {
                this.companyDetailsForm.get('bank_slip').setValue(this.responseupload.results.file);
                this.bank_ac_statement_url = this.responseupload.results.imageUrl;
              }
              if (target == 'company_stamp') {
                this.companyDetailsForm.get('company_stamp').setValue(this.responseupload.results.file);
                this.company_stamp_url = this.responseupload.results.imageUrl;
              }
              if (target == 'nif_certificate') {
                this.companyDetailsForm.get('nif_certificate').setValue(this.responseupload.results.file);
                this.nif_certificate_url = this.responseupload.results.imageUrl;
              }

            }
          },
          error => {
            this.ngxUiLoaderService.stop();
          });

      // const fileInput: any = document.getElementById(inputId);
      // const fileNameDisplay = document.getElementById(displayId);
      // if (fileInput.files.length > 0) {
      //   // const fileName = fileInput.files[0].name;
      //   // fileNameDisplay.textContent = `${fileName}`;
      //   if (this.currentLang == 'fr') {
      //     fileNameDisplay.textContent = `Cliquez pour voir le fichier`
      //   } else {
      //     fileNameDisplay.textContent = `Click to view File`
      //   }
      // } else {
      //   if (this.currentLang == 'fr') {
      //     fileNameDisplay.textContent = "Téléchargez une image ou déposez un fichier";
      //   } else {
      //     fileNameDisplay.textContent = "Upload image or drop a file";
      //   }
      // }
    }
  }

  generateMap(lat, long) {
    this.latitude = lat;
    this.longitude = long;
    const mapProperties = {
      center: new google.maps.LatLng(this.latitude, this.longitude),
      zoom: 5,
      mapTypeId: google.maps.MapTypeId.HYBRID,
    };
    this.map = new google.maps.Map(this.mapElement.nativeElement, mapProperties);
    
    // Initialize geocoder
    if (!this.geocoder) {
      this.geocoder = new google.maps.Geocoder();
    }
    
    // this.map.setOptions({draggable: false, zoomControl: false, scrollwheel: false, disableDoubleClickZoom: true})
    var pos = {
      lat: this.latitude,
      lng: this.longitude
    };
    console.log("latitude :", this.latitude, "latitude :", this.longitude)

    var marker = new google.maps.Marker({
      position: pos,
      map: this.map
    });

    // Remove old circle if it exists
    if (this.circle) {
      this.circle.setMap(null);
    }

    this.circle = new google.maps.Circle({
      map: this.map,
      radius: 0, // 10 miles in metres
      fillColor: '#fab525'
    });

    this.markers.push(marker);
    this.circle.bindTo('center', marker, 'position');

    // Add click event listener to map
    google.maps.event.addListener(this.map, 'click', (event: google.maps.MapMouseEvent) => {
      if (event.latLng) {
        const clickedLat = event.latLng.lat();
        const clickedLng = event.latLng.lng();
        
        // Update latitude and longitude
        this.latitude = clickedLat;
        this.longitude = clickedLng;
        this.companyDetailsForm.controls['latitude'].setValue(clickedLat);
        this.companyDetailsForm.controls['longitude'].setValue(clickedLng);
        
        var clickedPos = {
          lat: clickedLat,
          lng: clickedLng
        };
        
        // Update marker position
        this.setMarkers(clickedPos);
        this.map.setCenter(clickedPos);
        this.map.setZoom(15);
        
        // Reverse geocode to get address
        if (this.geocoder) {
          this.geocoder.geocode({ location: clickedPos }, (results, status) => {
            if (status === 'OK' && results && results[0]) {
              // Update the map_address form control with the formatted address
              this.companyDetailsForm.controls['map_address'].setValue(results[0].formatted_address);
              
              // Run inside Angular zone to ensure change detection
              this.ngzone.run(() => {
                console.log('Address from click:', results[0].formatted_address);
              });
            } else {
              console.error('Geocoding failed:', status);
              // If geocoding fails, still update the map but set address to empty or show coordinates
              this.companyDetailsForm.controls['map_address'].setValue(`${clickedLat}, ${clickedLng}`);
            }
          });
        }
      }
    });
  }
  setMarkers(pos: any) {
    this.clearMarkers();
    var marker = new google.maps.Marker({
      position: pos,
      map: this.map
    });
    this.markers.push(marker);
    
    // Update circle binding to new marker
    if (this.circle) {
      this.circle.bindTo('center', marker, 'position');
    }
  }

  clearMarkers() {
    for (var i = 0; i < this.markers.length; i++) {
      this.markers[i].setMap(null);
    }
    this.markers = [];
  }

  handleAddressChange(address, key) {
    if (key == 'search' && address.name) {
      var pos = {
        lat: address.geometry.location.lat(),
        lng: address.geometry.location.lng()
      };
      this.companyDetailsForm.controls['latitude'].setValue(address.geometry.location.lat());
      this.companyDetailsForm.controls['longitude'].setValue(address.geometry.location.lng());
      console.log(pos)
      const mapProperties = {
        zoom: 0,
        mapTypeId: google.maps.MapTypeId.HYBRID,
      };
      this.map.setZoom(10);
      this.map.setCenter(pos);
      this.setMarkers(pos);
    }
  }
  formatCNAMGS(event: any, id) {
    let value = event.target.value.replace(/-/g, '');

    // Insert hyphens based on the length of the value
    if (value.length >= 4 && value.length < 7) {
      value = value.slice(0, 3) + '-' + value.slice(3);
    } else if (value.length >= 7 && value.length < 11) {
      value = value.slice(0, 3) + '-' + value.slice(3, 6) + '-' + value.slice(6);
    } else if (value.length >= 11) {
      value = value.slice(0, 3) + '-' + value.slice(3, 6) + '-' + value.slice(6, 9) + '-' + value.slice(9);
    }
    if (id == 1) {
      this.companyDetailsForm.patchValue({ cnamgs: value });
    } else {
      this.companyDetailsForm.patchValue({ insurrance_no: value });
    }

  }
  formatCNSS(event: any) {
    let value = event.target.value.replace(/-/g, '');

    if (value.length >= 4 && value.length < 11) {
      value = value.slice(0, 3) + '-' + value.slice(3);
    } else if (value.length >= 11) {
      value = value.slice(0, 3) + '-' + value.slice(3, 10) + '-' + value.slice(10);
    }

    // Capitalize the last letter
    if (value.length > 0) {
      value = value.slice(0, -1) + value.slice(-1).toUpperCase();
    }
    this.companyDetailsForm.patchValue({ cnss: value });
  }
}
